import React, { useEffect, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { useDispatch, useSelector } from "react-redux";
import validate from "utils/validate";
import { ButtonLoader, Input, SelectInput } from "components/__new/common/form";
import { ReactComponent as IconReturn } from "assets/images/icons/project-icons/get-started-back.svg"
import { ReactComponent as EyeMasked } from "assets/images/icons/project-icons/eye-masked.svg"
import { ReactComponent as EyeRevealed } from "assets/images/icons/project-icons/eye-revealed.svg"
import * as auth from "store/auth/user/action";


export const GetStarted2 = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { signupLoading, signupForm, referralPointsLoading, referralPoints, userModules } = useSelector((s) => s.auth.user);
    const { signedUp } = useSelector((s) => s.auth.userPersist);

    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        jobTitle: "",
        phoneNumber: "",
        companyName: "",
        companyAddress: "",
        companySize: "",
        rcNumber: "",
        email: "",
        password: "",
        password_confirmation: "",
        referredFrom: "",
    })
    
    const [pwdShown, setPwdShown] = useState(false);
    const [confirmPwdShown, setConfirmPwdShown] = useState(false);

    // upon form submission, check json key with api key

    const submitForm = async (e) => {
        e.preventDefault();

        const validateForm = {...form, confirmPassword: form.password_confirmation};
        delete validateForm["password_confirmation"];
        delete validateForm["companyAddress"];
        const errors = validate(validateForm);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const params = {
                ...form,
                products: userModules,
                userType: "employer",
            }
            dispatch(auth.signUp2(params));
        }
    }

    useEffect(() => {
        dispatch(auth.getReferralPoints());

        if (Object.keys(signupForm).length > 0){
            const prevForm = {...form, ...signupForm};
            setForm(prevForm);
        }
        else{
            history.push("/get-started");
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (signedUp === true){
            history.push("/get-started/success");
        }
        // eslint-disable-next-line
    }, [signedUp])


    return (
        <>

            <DynamicHeadTag
                headerText="Get Started"
            />

            <div className="p-8">
                <div>
                    
                    <div className="text-center">
                        <div className="text-2xl font-semibold">
                            Create Admin Details
                        </div>
                    </div>

                    <div>
                        <form onSubmit={submitForm}>

                            <div className="mt-10 w-full max-w-md mx-auto md:mx-0 lg:w-96">

                                <div className="mb-5">
                                    <Link to="/get-started" className="hover:underline flex items-center">
                                        <IconReturn />
                                        <span className="ml-2">Back</span>
                                    </Link>
                                </div>

                                <Input type="text" label="First Name" placeholder="Enter First Name" value={form.firstName} onChange={(e) => setForm({...form, firstName: e.target.value})} required={true} />
                                <Input type="text" label="Last Name" placeholder="Enter Last Name" value={form.lastName} onChange={(e) => setForm({...form, lastName: e.target.value})} required={true} />
                                <Input type="text" label="Job Title" placeholder="Enter Job Title" value={form.jobTitle} onChange={(e) => setForm({...form, jobTitle: e.target.value})} required={true} />
                                <Input type="tel" label="Phone Number" placeholder="Enter Phone Number" value={form.phoneNumber} onChange={(e) => setForm({...form, phoneNumber: e.target.value})} required={true} />
                                <Input type="email" label="Business Email" placeholder="Enter Business Email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required={true} />
                                <Input
                                    label="Password" 
                                    autoComplete="off" 
                                    placeholder="Enter Password"
                                    type={pwdShown ? "text" : "password"} 
                                    rightIconClicked={() => setPwdShown(!pwdShown)}
                                    rightIcon={pwdShown ? <EyeRevealed /> :  <EyeMasked />}
                                    value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} 
                                />
                                
                                <Input 
                                    autoComplete="off" 
                                    label="Confirm Password" 
                                    placeholder="Confirm Password"
                                    value={form.password_confirmation} 
                                    type={confirmPwdShown ? "text" : "password"} 
                                    rightIconClicked={() => setConfirmPwdShown(!confirmPwdShown)}
                                    onChange={(e) => setForm({...form, password_confirmation: e.target.value})} 
                                    rightIcon={confirmPwdShown ? <EyeRevealed /> :  <EyeMasked />}
                                />
                                
                                <div>
                                    {(referralPointsLoading === true) && 
                                        <Input type="text" label="How did you hear about us?" value="Loading..." disabled={true} />
                                    }
                                    {(referralPointsLoading === false) && 
                                        <SelectInput label="How did you hear about us?" required={false} value={form.referredFrom} onChange={(e) => setForm({...form, referredFrom: e.target.value})}>
                                            <option value="">Select referral</option>
                                            {(referralPointsLoading === false) && (Object.keys(referralPoints).length > 0) && 
                                                <>
                                                    {Object.keys(referralPoints).map((referral, index) => (
                                                        <option key={index} value={referralPoints[referral]._id}>{referralPoints[referral].title}</option>
                                                    ))}
                                                </>
                                            }
                                        </SelectInput>
                                    }
                                </div>
                                
                                <div className="checkbox">
                                    <label className="cursor-pointer inline-block">
                                        <input type="checkbox" className="w-5 h-5 mr-2 form-checkbox float-left" required />
                                        <div className="text-sm text-gray-500 overflow-hidden">
                                            By clicking Sign up, you agree to our <br />
                                            <Link to={{pathname:"https://earnipay.com/terms"}} target="_blank" className="font-bold text-ep-primary-500 hover:underline">Terms and Conditions</Link>
                                            , and &nbsp;
                                            <Link to={{pathname:"https://earnipay.com/privacy-policy"}} target="_blank" className="font-bold text-ep-primary-500 hover:underline">Privacy Policy</Link>
                                        </div>
                                    </label>
                                </div>

                                <ButtonLoader type="submit" loading={signupLoading} className="btn btn-lg btn-block btn-ep-primary mt-8">
                                    Sign up
                                </ButtonLoader>
                                
                                <div className="mt-5 text-sm text-gray-500 text-center">
                                    Already have an account? &nbsp;
                                    <Link to="/login" className="font-semibold text-ep-primary hover:underline">Sign In</Link>
                                </div>

                            </div>

                        </form>
                    </div>

                </div>
            </div>
            
        </>
    )
}


export default GetStarted2;